import {Record} from 'immutable';
import {Int} from '@store/@types/util';

export type SkillId = Int;
export default class Skill extends Record({
  id: null,
  skill: null,
  accountId: null,
}) {
  readonly id: SkillId;
  readonly skill: string;
  readonly accountId: string;
  constructor(object: {id: string | number; skill: string; accountId: string}) {
    super({
      ...object,
      // api inconsistently returns strings/int.  normalize
      // TODO probably should fix the api
      id: typeof object.id === 'string' ? parseInt(object.id, 10) : object.id,
    });
  }
}
